// extracted by mini-css-extract-plugin
export default {"core-question":"Corequestions_core-question__I1tgA","close-width":"Corequestions_close-width__eKK+W"};